module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/cinematic_stock-avatar-c8283d8ad86a14aeb687b47e508b6fe9.jpg";